'use client';
import { classNames } from '@repo/ui/src/utils/classNames';
import type { SearchChipTab } from './index';

interface TabChipProps {
  tab: SearchChipTab;
  isActive: boolean;
  count?: number;
  searchTerm: string;
  onTypeChange: (searchType: string) => void;
}

const TabChip = ({ tab, isActive, count, searchTerm, onTypeChange }: TabChipProps) => {
  if (tab.redirectUrl) {
    return (
      <a
        href={`${tab.redirectUrl}${encodeURIComponent(searchTerm)}`}
        className="px-5 py-2 rounded-full border text-sm font-medium no-underline transition-colors cursor-pointer border-warm-300 text-neutral-700 bg-white hover:bg-warm-100"
      >
        {tab.tabName}
      </a>
    );
  }

  return (
    <button
      type="button"
      aria-pressed={isActive}
      onClick={() => !isActive && onTypeChange(tab.searchType)}
      className={classNames(
        'px-5 py-2 rounded-full border text-sm font-medium transition-colors cursor-pointer flex items-center gap-1.5',
        isActive
          ? 'bg-neutral-800 text-white border-neutral-800'
          : 'border-warm-300 text-neutral-700 bg-white hover:bg-warm-100',
      )}
    >
      {tab.tabName}
      {count != null && count > 0 ? (
        <span className="opacity-70 font-normal">({count.toLocaleString()})</span>
      ) : null}
    </button>
  );
};

export default TabChip;
